import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { IntegrationsApi } from '@shared/api/rest';
import type { IntegrationResponse } from '@shared/api/rest/integrations';
import { type IQueryParams, RequestStrategyEnum } from '@shared/api/models';

const getInitialIntegrations = createEffect((params: IQueryParams) => IntegrationsApi.getIntegrations(params?.signal));
const getIntegrations = createEffect((params: IQueryParams) => IntegrationsApi.getIntegrations(params?.signal));
const clearEvent = createEvent();

const $dataStore = createStore<IntegrationResponse[]>([])
  .on(getInitialIntegrations.done, (current, data) => data.result.data ?? current)
  .on(getIntegrations.done, (current, data) => data.result.data ?? current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getInitialIntegrations.pending, (_, data) => data)
  .on(getInitialIntegrations.fail, () => false)
  .on(getInitialIntegrations.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getInitialIntegrations, () => null)
  .on(getInitialIntegrations.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getInitialIntegrations.done, () => null)
  .on(getIntegrations, () => null)
  .on(getIntegrations.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getIntegrations.done, () => null)
  .reset(clearEvent);
$errorStore.watch((x) => $notificationStore.events.setError(x));

export const $integrationsStore = {
  events: {
    get: ApiUtils.wrapperApi(getInitialIntegrations, RequestStrategyEnum.Debounce),
    update: ApiUtils.wrapperApi(getIntegrations, RequestStrategyEnum.Debounce),
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
